import {
  ACTIONLIST_FETCHITEMS_LOAD,
  ACTIONLIST_FETCHITEMS_SUCCEED,
  ACTIONLIST_FETCHITEMS_FAIL,
  ACTIONLIST_CHANGETABLE_CHANGE,
  ACTIONLIST_SEARCHTABLE_EDIT,
  ACTIONLIST_SEARCHTABLE_SEARCH,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ACTIONLIST_FETCHITEMS_LOAD:
      return { ...state, isFetchItemsLoading: true, fetchItemsError: null }
    case ACTIONLIST_FETCHITEMS_SUCCEED:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: action.items,
        pagination: { ...state.pagination, total: action.total },
      }
    case ACTIONLIST_FETCHITEMS_FAIL:
      return {
        ...state,
        isFetchItemsLoading: false,
        items: null,
        fetchItemsError: action.fetchItemsError,
      }
    case ACTIONLIST_CHANGETABLE_CHANGE: {
      return {
        ...state,
        pagination: action.pagination,
        filters: action.filters,
        sorter: action.sorter,
      }
    }
    case ACTIONLIST_SEARCHTABLE_EDIT:
      return {
        ...state,
        search: action.search,
      }
    case ACTIONLIST_SEARCHTABLE_SEARCH:
      return {
        ...state,
        isSearching: action.isSearching,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/reducers/actionList.js